import AppLayout from "@/layouts/AppLayout";
import { IndexTabBarActionsProvider } from "@/components/Tabs/IndexTabBarActions";
import PeopleTabs from "./_components/PeopleTabs";

export default function TabLayout({ children }: { children: React.ReactNode }) {
  return (
    <AppLayout>
      <IndexTabBarActionsProvider>
        <PeopleTabs />
        <div className="flex flex-col">{children}</div>
      </IndexTabBarActionsProvider>
    </AppLayout>
  );
}
